module.exports = __webpack_public_path__ + "img/20_85.6735af02.png";